// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"fa3173b3","787":"91a225d6","802":"3fb37fa8"}[chunkId] + ".chunk.js";
};